import { render } from "./ProjectMark.vue?vue&type=template&id=6d4893bd&scoped=true"
import script from "./ProjectMark.vue?vue&type=script&lang=js"
export * from "./ProjectMark.vue?vue&type=script&lang=js"

import "./ProjectMark.vue?vue&type=style&index=0&id=6d4893bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4893bd"]])

export default __exports__